<template>
  <div class="relative">
    <div class="vx-navbar-wrapper navbar-full p-0">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColor">
            
            <!-- Logo -->
          <router-link tag="div" class="vx-logo cursor-pointer mx-auto my-2 flex items-center" to="/">
            <logo class="w-10 mr-2 fill-current text-primary" style="min-width:150px;"/>
            <!-- <span class="vx-logo-text text-primary" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span> -->
          </router-link>
          <!-- /Logo -->

      </vs-navbar>
    </div>
  </div>
</template>

<script>
import HNavMenuGroup  from './HorizontalNavMenuGroup.vue'
import HNavMenuHeader from './HorizontalNavMenuHeader.vue'
import HNavMenuItem   from './HorizontalNavMenuItem.vue'

import Logo from '../Logo.vue'

export default {
  props: {
    logo:          { type: String },
    title:         { type: String },
    // navbarColor  : { type: String, default: "#fff", },
    navMenuItems:  { type: Array,  required: true   }
  },
  components: {
    HNavMenuGroup,
    HNavMenuHeader,
    HNavMenuItem,
    Logo
  },
  computed: {
    navbarColor () {
      return this.$store.state.theme === 'dark' ? '#10163a' : '#fff'
    }
  },
  methods: {
    checkGrpChildrenActive (group) {
      const path        = this.$route.fullPath
      let active        = false
      const routeParent = this.$route.meta ? this.$route.meta.parent : undefined

      if (group.submenu) {
        group.submenu.forEach((item) => {
          if (active) return true
          if ((path === item.url || routeParent === item.slug) && item.url) { active = true } else if (item.submenu) { this.checkGrpChildrenActive(item) }
        })
      }

      return active
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/horizontalNavMenu.scss"
</style>
<style>
.main-horizontal.navbar-floating .router-content { margin-top: 5.1rem;}
.the-footer > p {margin: 0 auto;}
</style>
